import { IApiGeoPlace } from 'affiny-core/modules/api/repositories/maps/maps.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const MapResource = {
  getAffinyPlaceId: (
    providerPlaceId: string,
    lat: number,
    lng: number
  ): Promise<IApiGeoPlace> =>
    AffinyEndpoint.Geo.url(
      `/places?filter[provider_name]=photon&filter[provider_place_id]=${providerPlaceId}&filter[long]=${lng}&filter[lat]=${lat}`
    )
      .get()
      .json<IApiGeoPlace>(),
};
